export var inStoreErrors = {
    receiptNumberInvalidFormat: 'Please provide the 14-digit receipt number.',
    receiptNumberNotFound: "We can't find this receipt number. Please review the receipt details and try again.",
    salesDateInvalidFormat: 'Please provide a valid purchase date.',
    salesDateNotFound: 'Please provide the purchase date found on your receipt.',
    preTaxAmountInvalidFormat: 'Please enter the pre-tax amount found on your receipt (dollars and cents)',
    api404Error: 'Something went wrong. Please review your information or try again later.',
    receiptAlreadyAddedError: 'Receipt already added.',
};
export var onlineErrors = {
    orderNumberInvalidFormat: 'Please provide the 10-digit order number.',
    orderNumberNotFound: "We can't find this order number. Please review the order details and try again.",
    orderDateNotFound: 'Please provide the order date found on your order details.',
    orderDateInvalidFormat: 'Please provide a valid purchase date.',
    emailNotFound: 'Please provide the email found on your order details.',
    emailInvalidFormat: 'Please provide a valid email.',
    api404Error: 'Something went wrong. Please review your information or try again later.',
};
export var scanReceiptErrors = {
    preTaxAmountInvalidFormat: 'Please enter the pre-tax amount found on your receipt (dollars and cents)',
};
